import { Copy } from "lucide-react";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

const copyValue = async (value: unknown, label: string) => {
  try {
    const text = typeof value === "string" ? value : JSON.stringify(value, null, 2);
    await navigator.clipboard.writeText(text);
    toast.success(`${label} copiado`, {
      description: "Se copió al portapapeles",
      duration: 2000,
    });
  } catch {
    toast.error("No se pudo copiar", { duration: 2000 });
  }
};

/** A labelled, copyable JSON dump — the CRM sync payloads merchants quote to us
 *  when a sync fails. Lifted out of the old CrmSyncLogSection, whose own card was
 *  only ever mounted by the deleted inbox ActivitiesTab. */
export const JsonBlock = ({
  label,
  value,
  className,
}: {
  label: string;
  value: unknown;
  className?: string;
}) => (
  <div className="flex flex-col gap-1">
    <div className="flex items-center justify-between">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <button
        type="button"
        onClick={() => copyValue(value, label)}
        className="inline-flex items-center gap-1 text-xs font-medium text-muted-foreground transition-colors hover:text-palomma-primary"
      >
        <Copy className="size-3.5" />
        Copiar
      </button>
    </div>
    <pre
      className={cn(
        "max-h-56 overflow-auto whitespace-pre-wrap break-words rounded-md bg-muted p-2 text-xs leading-snug text-foreground",
        className
      )}
    >
      {typeof value === "string" ? value : JSON.stringify(value, null, 2)}
    </pre>
  </div>
);

export default JsonBlock;
